
import { useMessageGeneration } from "./operations/use-message-generation";
import { useSellerResponse } from "./operations/use-seller-response";

export const useMessageOperations = (id: string | undefined) => {
  const { generateResponse } = useMessageGeneration(id);
  const { pasteSellerResponse } = useSellerResponse(id);

  return {
    generateResponse,
    pasteSellerResponse
  };
};
